import React from 'react';

import styled from '@emotion/styled';
import { mq, contentWidth } from '../../_style';

const Container = styled.div`
  max-width: ${contentWidth}px;
  margin-right: auto;
  margin-left: auto;
  box-sizing: content-box;
  overflow: ${props => props.noHidden ? 'visible' : 'hidden'};
  & > * {
    box-sizing: border-box;
  }
  ${mq.pc} {
    padding-right: ${props => props.spread ? '240px' : '52px'};
    padding-left: ${props => props.spread ? '240px' : '52px'};
  }
  ${mq.sp} {
    padding-right: 20px;
    padding-left: 20px;
  }
`;

export default class ContentWidth extends React.Component {
  render() {
    return (
      <Container noHidden={this.props.noHidden} spread={this.props.spread}>{this.props.children}</Container>
    );
  }
}
